// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".glightbox-button-hidden{display:none}.plyr{--plyr-color-main:#174e42}", "",{"version":3,"sources":["webpack://./src/styles/vendors/glightbox.css"],"names":[],"mappings":"AAAA,yBACE,YACF,CAEA,MACE,yBACF","sourcesContent":[".glightbox-button-hidden {\n  display: none;\n}\n\n.plyr {\n  --plyr-color-main: #174e42;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
